import { get } from '../../utils/object-helpers';

<if(state.isShow)>
    $ {
        const accessibilityText = get(input, 'accessibilityText', '');
        const size = get(input, 'size', 'large');
        const name = get(input, 'spinnerId', '');
        const spinnerStyle = get(state, 'spinnerStyle', '');
        let outerClass = '';
        let innerClass = '';
        let useMask = false;

        if (size === 'large') {
            outerClass = 'str-loading-spinner';
            innerClass = 'str-loading-spinner__spinner';
            useMask = true;
        }
    }
    <div class=outerClass key="str-loading-spinner" name=name>
        <div class=innerClass style=spinnerStyle>
            <ebay-progress-spinner 
                size=size
                aria-live="polite" 
                aria-label=accessibilityText />
        </div>
        <if(useMask)>
            <div class="str-loading-spinner__mask"></div>
        </if>
    </div>
</if>
